import React, { FunctionComponent } from 'react'
import cx from 'classnames'
import {
  observer
} from 'mobx-react'
import snakeCase from 'lodash.snakecase'
import { CellValue } from './CellValue'
import { HeaderValue } from './HeaderValue'
import SchemerModel from '../../core/SchemerModel'

export interface NestedRowProps {
  isColHeader?: boolean
  // width: number
  valueRaw: SchemerModel
}

export const NestedRow: FunctionComponent<NestedRowProps> = observer(props => {
  const {
    isColHeader,
    valueRaw
    // width
  } = props

  const row = valueRaw
  const nestedCols = row.tableColumns
  const columnKeys = Array.from(nestedCols.keys())
  
  // const totalNestedWidth = columnKeys.reduce((out: number, key: string) => {
  //   const colConfig = nestedCols.get(key)
  //   const innerColWidth = colConfig && colConfig.width ? colConfig.width : 100
  //   return out + innerColWidth
  // }, 0)

  return (
    <div className={cx(`sch_row_nested`, row.classNames)}>
      {columnKeys.map(colKey => {
        // const colConfig = nestedCols.get(colKey)
        // const innerColWidth = colConfig ? Math.floor(totalNestedWidth / (colConfig.width || 50)) : 50

        return (
          <div 
            key={colKey}
            className={`sch_cell_nested col_${snakeCase(colKey)}`}
            // data-nested-col-key={colKey}
            // style={{
            //   width: innerColWidth
            // }}
          >
            {isColHeader ? (
              <HeaderValue
                columnKey={colKey}
                row={valueRaw}
                // width={innerColWidth}
                isTopLevel={false}
              />
            ) : (
              <CellValue
                columnKey={colKey}
                // width={innerColWidth}
                row={valueRaw}
              />
            )}
          </div>
        )
      })}
    </div>
  )
})

NestedRow.displayName = "Schemer.NestedRow"